import './radioButtonGroupComponent.scss'
import {FormControl, FormHelperText} from "@mui/material";
import RadioGroup from "@material-ui/core/RadioGroup";
import React, {useEffect} from 'react';
import RadioButtonComponent from "../radio-button/radioButtonComponent";

interface RadioButtonGroupComponentProps {
    name: string;
    size?: "medium" | "small" | undefined;
    color?: "primary" | "secondary" | "default"|"info" | undefined;
    options: any[];
    isValueBoolean?: boolean; // ***** this must be TRUE when value is a boolean type value *****
    direction?: "row" | "column";
    titleKey?: string;
    valueKey?: string;
    onUpdate?: Function;
    id?: any;
    value?: any;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom' | undefined;
    hasError?: boolean;
    errorMessage?: any;
    disabled?: boolean;
}

const RadioButtonGroupComponent = (props: RadioButtonGroupComponentProps) => {

        const [value, setValue] = React.useState(props.value);
        const {options, onUpdate, name, id, hasError, errorMessage,disabled} = props;

        let {color, size, direction, labelPlacement, titleKey, valueKey, isValueBoolean} = props;

        if (!color) color = "info";
        if (!direction) direction = "column";
        if (!size) size = "medium";
        if (!titleKey) titleKey = "title";
        if (!valueKey) valueKey = "code";

        useEffect(() => {
            setValue(props.value);
        }, [props.value]);

        return (
            <FormControl disabled={disabled} error={hasError}>
                <RadioGroup
                    row={direction === 'row'}
                    id={id}
                    name={name}
                    value={value}
                >
                    {
                        options?.map((option: any, index) => (
                            <div key={option[titleKey || ''] + index}>
                                <RadioButtonComponent
                                    label={titleKey ? option[titleKey] : option}
                                    value={valueKey ? option[valueKey] : option}
                                    size={size}
                                    color={color}
                                    name={name}
                                    checked={valueKey ? option[valueKey] === value : option === value}
                                    labelPlacement={labelPlacement}
                                    onUpdate={(value: any) => {
                                        let selectedValue: any = value;
                                        if (isValueBoolean) {
                                            selectedValue = selectedValue === true;
                                        }
                                        setValue(selectedValue);
                                        if (onUpdate) {
                                            onUpdate(selectedValue);
                                        }
                                    }}
                                />&nbsp;
                            </div>
                        ))
                    }
                </RadioGroup>
                <FormHelperText>
                    {hasError && errorMessage}
                </FormHelperText>
            </FormControl>
        );

    }

;

export default RadioButtonGroupComponent;
